/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListToolsetsSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListToolsetsSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListToolsetsSecurity = {
  option1?: ListToolsetsSecurityOption1 | undefined;
  option2?: ListToolsetsSecurityOption2 | undefined;
};

export type ListToolsetsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListToolsetsSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListToolsetsSecurityOption1$outboundSchema: z.ZodMiniType<
  ListToolsetsSecurityOption1$Outbound,
  ListToolsetsSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listToolsetsSecurityOption1ToJSON(
  listToolsetsSecurityOption1: ListToolsetsSecurityOption1,
): string {
  return JSON.stringify(
    ListToolsetsSecurityOption1$outboundSchema.parse(
      listToolsetsSecurityOption1,
    ),
  );
}

/** @internal */
export type ListToolsetsSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListToolsetsSecurityOption2$outboundSchema: z.ZodMiniType<
  ListToolsetsSecurityOption2$Outbound,
  ListToolsetsSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listToolsetsSecurityOption2ToJSON(
  listToolsetsSecurityOption2: ListToolsetsSecurityOption2,
): string {
  return JSON.stringify(
    ListToolsetsSecurityOption2$outboundSchema.parse(
      listToolsetsSecurityOption2,
    ),
  );
}

/** @internal */
export type ListToolsetsSecurity$Outbound = {
  Option1?: ListToolsetsSecurityOption1$Outbound | undefined;
  Option2?: ListToolsetsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListToolsetsSecurity$outboundSchema: z.ZodMiniType<
  ListToolsetsSecurity$Outbound,
  ListToolsetsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListToolsetsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListToolsetsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listToolsetsSecurityToJSON(
  listToolsetsSecurity: ListToolsetsSecurity,
): string {
  return JSON.stringify(
    ListToolsetsSecurity$outboundSchema.parse(listToolsetsSecurity),
  );
}

/** @internal */
export type ListToolsetsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListToolsetsRequest$outboundSchema: z.ZodMiniType<
  ListToolsetsRequest$Outbound,
  ListToolsetsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listToolsetsRequestToJSON(
  listToolsetsRequest: ListToolsetsRequest,
): string {
  return JSON.stringify(
    ListToolsetsRequest$outboundSchema.parse(listToolsetsRequest),
  );
}
